import { init, plugin } from '@faceup/devtools'
import { featureFlagsList, PostHogProvider, posthog } from '@faceup/posthog'
import {
  dropConsoleLogRecord,
  maskDeepMutate,
  maskSensitiveAttribute,
  maskTokenInUrl,
  registerStaleChunkReload,
} from '@faceup/utils'
import { createRoot } from 'react-dom/client'
import { App } from './App/App'
import './styles.css'

registerStaleChunkReload()

posthog.init(import.meta.env.VITE_POSTHOG_TOKEN, {
  api_host: 'https://a.faceup.com',
  ui_host: 'https://eu.posthog.com',
  persistence: 'memory',
  autocapture: false,
  capture_dead_clicks: false,
  enable_recording_console_log: false,
  logs: {
    beforeSend: dropConsoleLogRecord,
  },
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '.sensitive',
    maskAttributeFn: maskSensitiveAttribute,
  },
  before_send: event => {
    if (!event) {
      return event
    }

    event.properties['$ip'] = '0.0.0.0'
    // The invite token unlocks the invitee's details, so it must not travel with the page URL
    maskDeepMutate(event, maskTokenInUrl)

    return event
  },
})

if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
  init({
    plugins: [
      plugin.requests,
      plugin.cache,
      plugin.analytics,
      plugin.console,
      plugin.playground,
      plugin.cleaner,
      plugin.translations,
      plugin.safeArea,
      plugin.httpAnalyzer,
      plugin.featureFlags({
        allFeatureFlags: featureFlagsList,
        useLocalStorage: true,
        posthogFeatureFlagsMethods: {
          getFlagsWithDetails: () => posthog.featureFlags.getFlagsWithDetails(),
          overrideFeatureFlags: options => posthog.featureFlags.overrideFeatureFlags(options),
        },
      }),
    ],
    apiUrl: import.meta.env.VITE_API_URL ?? '',
  })
}

const container = document.getElementById('app')
if (container) {
  const root = createRoot(container)
  root.render(
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  )
}
